// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { CartItem } from "@coveo/headless-react/ssr-commerce";
import { CartResult, GetCartApiParameter } from "@insite/client-framework/Services/CartService";
import { Handler, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { CartLineModel } from "@insite/client-framework/Types/ApiModels";
import { CartHook } from "@NA/Components/Coveo/Contexts/CoveoHooksContext";
import { loadCartItemsFromStorage, saveCartItemsToStorage } from "@NA/Utils/Coveo/CoveoUtils";

type HandlerType = Handler<
    {
        shouldLoadFullCart?: boolean;
        replaceCart?: boolean;
        getPromotions?: boolean;
        getCartLines?: boolean;
        getCostCodes?: boolean;
    } & HasOnSuccess,
    {
        apiParameter: GetCartApiParameter;
        apiResult: CartResult;
        needFullCart: boolean;
    }
>;

const CoveoLoadCartTap =
    (cart: CartHook): HandlerType =>
    props => {
        const { methods } = cart;

        const makeProductItemsForEvent = (cart: CartLineModel[] | null | undefined): CartItem[] => {
            if (!cart) {
                return [];
            }
            return cart.map(
                (p: any): CartItem => ({
                    productId: p.productId,
                    name: p.productName,
                    price: p.pricing.actualPrice,
                    quantity: p.qtyOrdered,
                }),
            );
        };

        const products = props.apiResult.cart.cartLines;
        const coveoLocalStorageCart = loadCartItemsFromStorage() || [];
        const convertedProducts = makeProductItemsForEvent(products);
        saveCartItemsToStorage(convertedProducts)

        const productsToBeRemoved = coveoLocalStorageCart
            .filter((product: any) => {
                return !convertedProducts.some((convertedProduct: any) => {
                    return convertedProduct.productId === product.productId;
                });
            })
            .map((product: any) => {
                return { ...product, quantity: 0 };
            });

        const itemsToUpdate = [...convertedProducts, ...productsToBeRemoved];
        itemsToUpdate.forEach((product: any) => {
            methods?.updateItemQuantity(product);
        });
    };

export default CoveoLoadCartTap;
